<template>
  <SidebarHeader
    :isLoading="isLoading"
    :titleHref="
      reisetermin
        ? '#/reisetermine/' + reisetermin.id + '?vorgangdetailstab=fluege&scrollToFlugdaten=true'
        : null
    "
    :kuerzel="reisetermin?.reiseterminkuerzel?.substring(0, 6)"
    :datum="startdatumFormatted"
    :ursprung="
      reisetermin?.ursprungsreiseterminId
        ? {
            id: reisetermin.ursprungsreiseterminId,
            kuerzel: reisetermin.ursprungsreisetermin?.reiseterminkuerzel,
          }
        : null
    "
    :ersatz="
      reisetermin?.ersatztermin
        ? { id: reisetermin.ersatztermin.id, kuerzel: reisetermin.ersatztermin.reiseterminkuerzel }
        : null
    "
    @go-up="$emit('go-up')"
    @go-down="$emit('go-down')"
    @close="$emit('close')"
  >
    <template #actions>
      <b-button
        v-if="reisetermin"
        class="btn btn-icon icon-button"
        size="sm"
        v-b-tooltip.hover.bottom
        title="Neu laden"
        :disabled="isLoading || !disableSpeichernButton"
        @click="$emit('reload')"
      >
        <RotateCcw :size="16" />
      </b-button>
      <b-button
        v-if="reisetermin"
        class="btn btn-icon icon-button"
        size="sm"
        v-b-tooltip.hover.bottom
        title="Reisestammdaten"
        :href="
          '#/reisen/' +
          reisetermin.reise.reisekuerzel +
          '/reisestammdaten?reiseterminAbreisedatum=' +
          reisetermin.abreisedatum.substring(0, 10)
        "
        target="_blank"
      >
        <Pencil :size="16" />
      </b-button>
      <b-button
        class="btn btn-icon icon-button"
        size="sm"
        v-b-tooltip.hover.bottom
        title="Aufgabe erstellen"
        v-b-modal.modalAufgabeEdit
        @click="$emit('aufgabe-erstellen')"
      >
        <ListChecks :size="16" />
      </b-button>
      <b-button
        class="dialog-btn"
        size="sm"
        @click="$emit('save')"
        :variant="disableSpeichernButton ? 'secondary' : 'primary'"
        :disabled="disableSpeichernButton"
      >
        Speichern
      </b-button>
    </template>
  </SidebarHeader>
</template>

<script>
import { format } from 'date-fns';
import { ListChecks, Pencil, RotateCcw } from 'lucide-vue';
import SidebarHeader from '@/components/common/sidebar-section/sidebar-header.vue';

export default {
  name: 'SidebarFlugplanungHeader',
  components: { ListChecks, Pencil, RotateCcw, SidebarHeader },
  props: {
    // Steuert die Ladeanzeige im Header
    isLoading: { type: Boolean, default: false },
    // Der aktive Reisetermin für Titel, Links und Reisestammdaten-Button
    reisetermin: { type: Object, default: null },
    // Deaktiviert den Speichern-Button, wenn keine speicherbaren Änderungen vorliegen
    disableSpeichernButton: { type: Boolean, default: true },
  },
  computed: {
    startdatumFormatted() {
      return this.reisetermin?.startdatum ? format(new Date(this.reisetermin.startdatum), 'dd.MM.yyyy') : '';
    },
  },
};
</script>
